import {TableFilterConditionsConnection} from '../filterTableTool.enums';
import {TableFilterRules} from '../filterTableTool.types';
import filterTableData from './filterTableData';

function filterTableDataWithGroups<DataType extends object>(
  data: DataType[],
  rules: TableFilterRules,
): DataType[] {
  const {conditionGroups, groupsConnection} = rules;

  if (conditionGroups.length === 0) {
    return data;
  }

  return data.filter((item) => {
    const groupResults = conditionGroups.map((group) => {
      return filterTableData([item], group.conditions, group.conditionsConnection).length > 0;
    });

    if (groupsConnection === TableFilterConditionsConnection.And) {
      return groupResults.every((result) => result);
    } else {
      return groupResults.some((result) => result);
    }
  });
}

export default filterTableDataWithGroups;
